import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Departamento, Empresa, getDepartamentos, getPadronTipos, Localidad, Padron, PadronTipo, PadronTipoCore } from 'src/app/chacra-core';
import LOCALIDADES from '../../../../../assets/Localidades.json';

@Component({
  selector: 'app-padron-list',
  templateUrl: './padron-list.component.html',
  styleUrls: ['./padron-list.component.scss']
})
export class PadronListComponent implements OnInit {
  private _padrones: Padron[] = [];
  private _empresas: Empresa[] = [];

  departamentos: Departamento[] = getDepartamentos();
  tipos: PadronTipoCore[] = getPadronTipos();
  localidades: Localidad[][] = [];

  padronesForm: FormGroup;
  deletePadronQuest: boolean[] = [];

  @Input() canManipulate = true;

  @Output() padronesEvent = new EventEmitter<Padron[]>();

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit() { }

  get padrones(): Padron[] {
    return this._padrones;
  }

  @Input()
  set padrones(value: Padron[]) {
    this._padrones = value;
    this.deletePadronQuest = value.map(v => false);
    this.generateForm();
  }

  get empresas(): Empresa[] {
    return this._empresas;
  }

  @Input()
  set empresas(value: Empresa[]) {
    this._empresas = value;
  }

  generateForm(){
    const items = this.padrones.map((p, index) => this.createItemForm(p, index));
    this.padronesForm = this.formBuilder.group({
      items: this.formBuilder.array(items)
    });
  }

  createItemForm(padron: Padron = null, index: number = 0): FormGroup {
    if (!padron) {
      padron = new Padron();
    }
    else{
      if(padron.departamentoId){
        this.localidades[index] = LOCALIDADES.filter(l => l.DepartamentoId.toString() === padron.departamentoId);
      }
    }

    const form = this.formBuilder.group({
      padronId: [padron.padronId, [
        Validators.required,
        Validators.pattern('[0-9]*')
      ]],
      padronTipo: [padron.padronTipo, [Validators.required]],
      padronArea: [padron.padronArea, [Validators.required]],
      departamento: [padron.departamentoId, [Validators.required]],
      localidad: [padron.padronLocalidad]
    });

    form.get('departamento').valueChanges.subscribe(departamentoId => {
      if (departamentoId) {
        this.localidades[index] = LOCALIDADES.filter(l => l.DepartamentoId.toString() === departamentoId);
        if (this.localidades[index].length > 0) {
          form.patchValue({ localidad: this.localidades[index][0] });
        }
      }
    });

    return form;
  }

  getItems(): FormArray {
    return this.padronesForm.get('items') as FormArray;
  }

  getControl(index: number): AbstractControl {
    const items = this.getItems();
    return items['controls'][index];
  }

  isPadronRural(index: number) {
    const item = this.getControl(index);
    const padronTipo = item.get('padronTipo').value;
    return padronTipo === PadronTipo.Rural;
  }

  newPadron() {
    const ps = [...this.padrones];
    ps.push(new Padron());
    this.padrones = ps;
  }

  setDeletePadronQuest(index: number){
    this.deletePadronQuest[index] = true;
  }

  remove(index: number) {
    let pAux = [...this.padrones];
    pAux.splice(index, 1);
    this.padrones = pAux;
    this.padronesEvent.emit(this.padrones);
  }

  save(index: number){

    const item = this.getControl(index);

    const departamento = this.departamentos.find(d => d.id.toString() === item.value.departamento);
    const padron: Padron = {
      padronId: item.value.padronId,
      padronPropietarioId: null,
      padronTipo: item.value.padronTipo,
      padronArea: item.value.padronArea,
      departamentoId: departamento ? departamento.id.toString() : '',
      departamentoNombre: departamento ? departamento.nombre : '',
      padronLocalidad: !this.isPadronRural(index) ? item.value.localidad : '',
      padronFueSeleccionado: true
    };

    const ps = [...this.padrones];
    ps[index] = padron;
    this.padrones = ps;
    this.padronesEvent.emit(this.padrones);
    item.markAsUntouched()
  }
}
